import LocalStorage from "./LocalStorage";

type coreReturnStatus = boolean | undefined;

export const saveCoreReturnsStatus = (value: boolean) =>
  LocalStorage.setJSONValue("showCoreReturns", { value });

const getStoredCoreReturnsStatus = (): coreReturnStatus =>
  LocalStorage.getJSONValue("showCoreReturns")?.value as coreReturnStatus;

const getShowCoreReturnsFromUrl = (): coreReturnStatus => {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get("showCoreReturns")?.toLowerCase();
  if (value === undefined) return value;
  return value === "true";
};

export const getShowCoreReturnStatus = (): coreReturnStatus => {
  let showCoreReturnStatus;
  const showCoreReturnsFromUrl = getShowCoreReturnsFromUrl();

  if (showCoreReturnsFromUrl !== undefined) {
    showCoreReturnStatus = showCoreReturnsFromUrl;
  } else {
    showCoreReturnStatus = getStoredCoreReturnsStatus();
  }
  if (showCoreReturnStatus !== undefined)
    saveCoreReturnsStatus(showCoreReturnStatus);

  return showCoreReturnStatus;
};
